module.exports = __webpack_public_path__ + "video_author_blue-77c6a4e4.svg";